import { useRef, useState } from "react";

/**
 * @name useLoadStatus PDF加载状态获取
 */
export default function useLoadStatus() {
  const fn = useRef<Record<"reject" | "resolve", Function>>();

  const [error, setError] = useState(false);

  function getLoadStatus() {
    setError(false);
    return new Promise((resolve, reject) => {
      fn.current?.resolve();
      fn.current = { resolve, reject };
    });
  }

  function onLoadError() {
    setError(true);
    fn.current?.reject();
  }

  function onLoadSuccess() {
    setError(false);
    fn.current?.resolve();
  }

  return {
    error,
    setError,
    onLoadError,
    onLoadSuccess,
    getLoadStatus,
  };
}
